/**
 * Helper function to check if user belongs to any of the required groups
 * @param userOwnership - User's ownership entity refs (groups they belong to)
 * @param requiredGroups - Array of required group entity refs (e.g., ['group:default/admins'])
 * @returns boolean indicating if user has access
 */
export const hasAccess = (
  userOwnership: string[] = [],
  requiredGroups: string[] = [],
): boolean => {
  // If no groups required, allow access to all authenticated users
  if (requiredGroups.length === 0) {
    return true;
  }

  // Check if user belongs to any of the required groups
  return requiredGroups.some(group => userOwnership.includes(group));
};

/**
 * Hook to check if current user has access based on required groups
 * @param requiredGroups - Array of required group entity refs
 * @returns boolean indicating if user has access
 */
export const useHasAccess = (
  userOwnership: string[] = [],
  requiredGroups: string[] = [],
): boolean => {
  return hasAccess(userOwnership, requiredGroups);
};
